// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2OcV1","col":"styles_col__3F11L","fulfillmentStatus":"styles_fulfillmentStatus__28mgB","emailCol":"styles_emailCol__3_KAq"};